// Endpoints that authenticate the caller themselves. A 401 from any of them
// is the endpoint's own verdict — a wrong OTP code, a dead refresh token — not
// an expired session, so the response interceptor must surface it as is
// instead of spending the refresh token on it and reporting the refresh
// failure (which carries no status) to the screen.
export const SELF_AUTHENTICATING_PATHS = [
  "/auth/refresh",
  "/auth/email/",
  "/auth/telegram",
  "/auth/google",
  "/auth/yandex",
  "/auth/logout"
] as const

export const isSelfAuthenticatingUrl = (url?: string): boolean =>
  !!url && SELF_AUTHENTICATING_PATHS.some((path) => url.includes(path))
